import {
  createTemperatureDetectorDeviceAsync,
  deleteTemperatureDetectorDeviceAsync,
  getTemperatureDetectorDeviceByIdAsync,
  updateTemperatureDetectorDeviceAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateTemperatureDetectorDeviceAsync = () =>
  useMutation(createTemperatureDetectorDeviceAsync);

export const useGetTemperatureDetectorDeviceByIdAsync = () =>
  useMutation(getTemperatureDetectorDeviceByIdAsync);

export const useUpdateTemperatureDetectorDeviceAsync = () =>
  useMutation(updateTemperatureDetectorDeviceAsync);

export const useDeleteTemperatureDetectorDeviceAsync = () =>
  useMutation(deleteTemperatureDetectorDeviceAsync);
